import RankNineteen from '@assets/icons/rank-nineteen.svg'
import { Icon } from './Icon'

export const RankNineteenIcon = Icon(RankNineteen)
